module.exports = __webpack_public_path__ + "static/the-little-book-of-talent-3666369af363edb6e9d32ce422778cde.jpg";